import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import paths from 'assets/routes/paths';
import { useOrderFinish } from '../../../../hooks/useApi/useOrderApi';
import Signature from '../../../global/Form/Signature/Signature';
import CascadeClosureModal from 'components/admin/ODT/CascadeClosureModal';
import RutRecepcionistaField from 'components/specialist/Recepcionista/RutRecepcionistaField';

function FinishOrderForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = useForm();
  const [post] = useOrderFinish();
  const [pendingBody, setPendingBody] = useState(null);

  // El submit del form no postea directamente: abre el modal de confirmacion
  // con la preview de la cascada (tareas finalizadas / huerfanos del budget /
  // pendientes). El tecnico selecciona que hallazgos cerrar y recien ahi se
  // hace el POST incluyendo la lista en hallazgosACerrar.
  const openCascadeModal = () => {
    const body = { ...form.getFieldsValue(), idOrder: id };
    setPendingBody(body);
  };

  const handleConfirm = async ({ hallazgosACerrar }) => {
    const result = await post({ ...pendingBody, hallazgosACerrar });
    setPendingBody(null);
    if (result.state === 'success') {
      return navigate(paths.relative.specialist.order);
    }
  };
  return (
    <div>
      <div className="d-flex flex-allign-items-center flex-justify-content-between">
        <Link to={paths.relative.specialist.orderDetail(id)}>
          <Button icon={<ArrowLeftOutlined />} type={'primary'} className="mr-1 content-box" />
        </Link>
        <h3 className="font-w-title">Finalizar Orden N°{id}</h3>
      </div>
      <Card className="mt-5 wd-60 wd-md mv-c">
        <Form form={form} onFinish={openCascadeModal} requiredMark={false}>
          {/* Sin autocompletado: el detalle de la orden no expone el cliente, y sin el
              cliente no se puede acotar la búsqueda. Se captura el RUT igual, que es
              lo que permite atender después los derechos de quien firma. */}
          <RutRecepcionistaField form={form} />
          <Form.Item
            name="recepcionist_name"
            label="Nombre del recepcionista"
            rules={[
              {
                required: true,
                message: 'Debe ingresar el nombre de quien recibe el comprobante',
              },
            ]}
            labelCol={{ span: 24 }}
          >
            <Input placeholder="Ingresar nombre de recepcionista" />
          </Form.Item>
          <Form.Item
            label="Cargo de recepción"
            name="recepcionist_charge"
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: 'El cargo del recepcionista es obligatorio',
              },
            ]}
          >
            <Input placeholder="Cargo de quien recibe" />
          </Form.Item>
          <Form.Item
            label="Firma recepcionista"
            name="recepcionist_signature"
            rules={[
              {
                required: true,
                message: 'La firma del recepcionista es obligatoria',
              },
            ]}
            labelCol={{ span: 24 }}
          >
            <Signature role="recep" />
          </Form.Item>
          <Form.Item
            label="Firma Especialista"
            name="specialist_signature"
            rules={[
              {
                required: true,
                message: 'La firma del especialista es obligatoria',
              },
            ]}
            labelCol={{ span: 24 }}
          >
            <Signature role="spec" />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary">
              Finalizar
            </Button>
          </Form.Item>
        </Form>
      </Card>
      <CascadeClosureModal
        open={!!pendingBody}
        idOrder={id}
        onClose={() => setPendingBody(null)}
        onConfirm={handleConfirm}
        confirmLabel="Firmar y cerrar ODT"
      />
    </div>
  );
}

export default FinishOrderForm;
